import { render, staticRenderFns } from "./seckillGoods.vue?vue&type=template&id=7614b11a&scoped=true&"
import script from "./seckillGoods.vue?vue&type=script&lang=js&"
export * from "./seckillGoods.vue?vue&type=script&lang=js&"
import style0 from "./seckillGoods.vue?vue&type=style&index=0&id=7614b11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7614b11a",
  null
  
)

export default component.exports